import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "../styles/listDetails.css";
import "../styles/aiSuggestion.css";
import LoadingIcon from "../images/Loading_icon.gif";
import MSbuttons from "../components/ListDetails/MSbuttons";
import ProjectTitle from "../components/ListDetails/ProjectTitle";
import ViewProjectInfo from "../components/ListDetails/ViewProjectInfo";
import ProjectExpertRow from "../components/ListDetails/ProjectExpertRow";
import Swal from "sweetalert2";
import EmailComposer from "./EmailComposer";
import DatabasePopupList from "../components/ListDetails/DatabasePopupList";

import {
  ListDetailsContext,
  ListDetailsProvider,
} from "../contexts/ListDetailsContext";
import { UrlContext } from "../contexts/UrlContext";

export default function ListDetails() {
  useEffect(() => {
    document.title = "List Details";
  }, []);

  const {
    tableData,
    backupData,
    setTableData,
    dataFetched,
    setPageID,
    setLoading,
    loading,
    project,
    setProject,
    fieldsLoading,
  } = useContext(ListDetailsContext);
  const id = useParams().id;
  const [searchExpand, setSearchExpand] = useState(false);
  const nameInputRef = useRef(null);
  // const [backupData, setBackupData] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [showButtons, setShowButtons] = useState(false);
  const [expertIds, setExpertIds] = useState([]);
  const [noConFound, setNoConFound] = useState(false);
  const [titleCount, setTitleCount] = useState(0);
  const [filterCount, setFilterCount] = useState(0);
  const [composeEmail, setComposeEmail] = useState(false);
  const [emailDetails, setEmailDetails] = useState(false);
  const [emailButtonClicked, setEmailButtonClicked] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedConsulData, setSelectedConsulData] = useState("");
  const { API_URL } = useContext(UrlContext);
  const [loadingPopup, setLoadingPopup] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);

  const appendExpertId = (id) => {
    const newExpertIds = [...expertIds];
    newExpertIds.push(id);
    setExpertIds(newExpertIds);
  };
  const removeExpertId = (id) => {
    const newExpertIds = expertIds.filter((expertId) => expertId !== id);
    setExpertIds(newExpertIds);
  };

  useEffect(() => {
    if (expertIds.length > 0) {
      setShowButtons(true);
    } else {
      setShowButtons(false);
    }
  }, [expertIds]);

  useEffect(() => {
    setPageID(id);
  }, [id]);

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    selectedConsulData["lang"] = event.target.value;
    setEmailButtonClicked(false);
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}send-email`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(selectedConsulData, { lang: event.target.value }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          // setEmailCount(emailCount+1)
          window.location.reload();
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Database connection failed!",
        });
      });
  };
  useEffect(() => {
    if (filterName) {
      const filteredData = tableData.filter((item) => {
        const name = item?.expert.Name.toLowerCase();
        return name.includes(filterName.toLowerCase());
      });
      setTableData(filteredData);
    } else {
      setTableData(backupData);
    }
    // setFilterCount(filterCount + 1);
  }, [filterName, backupData]);
  return (
    <>
      <ProjectTitle project={project} />
      <div className="relative flex items-center justify-center">
        <div className="w-[97%]">
          <div className="project-inside-navbar">
            {/* <StatusList project_id={project?.id}/> */}
            <div className="project-navbar-right">
              <ViewProjectInfo project_id={project?.id} />
              {/* <EmailTemplate
                project_name={project?.name}
                project_id={project?.id}
              /> */}
              <button className="btn" onClick={() => setOpenSearch(true)}>
                <i className="fa-solid fa-database" /> Search database
              </button>
              {/* <AISuggestion project_id={project?.id} /> */}
              {/* <Link to={`/ProjectSummary/${project?.id}`} target="_blank" rel="noopener noreferrer" >
                <button className="btn">
                  <i className="fa-solid fa-chart-column" /> Summary
                </button>
              </Link> */}
            </div>
            <div className="project-navbar-left">
              {showButtons && (
                <MSbuttons project_id={project?.id} expertIds={expertIds} />
              )}
            </div>
          </div>
          <div className="prjdetails-table">
            <ul className="prjdetails-filters list-unstyled form-inline">
              <li className="prjdetails-filter">
                <span className="no-select">Search Name</span>
                <div className="prjdetails-searchbox">
                  <input
                    className={
                      searchExpand
                        ? "prjdetails-search-input prjdetails-search-expand"
                        : "prjdetails-search-input"
                    }
                    placeholder="Search Name"
                    onChange={(e) => {
                      setFilterName(e.target.value);
                    }}
                    value={filterName}
                    ref={nameInputRef}
                  />
                  <i
                    className="prjdetails-search-icon fa-solid fa-magnifying-glass"
                    onClick={(e) => {
                      setSearchExpand(!searchExpand);
                      // nameInputRef.current.focus()
                    }}
                  />
                </div>
              </li>
              <li style={{ width: "320px" }}></li>
              {/* <li className="pjdetails-filter-li no-select">
                <select className="pjdetails-status-filter"
                  value={statusFilter}
                  onChange={(e)=> {
                    setStatusFilter(e.target.value)
                  }}
                >
                    <option value=''>All</option>
                    <option value="0">No Information</option>
                    <option value="Responded">Responded</option>
                    <option value="Interested">Interested</option>
                    <option value="Partially Available">Partially Available</option>
                    <option value="Not Available">Not Available</option>
                    <option value="Participated">Participated</option>
                </select>
                
              </li> */}
              <li style={{ width: "156px" }}></li>
              <li style={{ width: "180px" }}></li>
            </ul>

            {dataFetched && !loading ? (
              <>
                {tableData?.length > 0 &&
                  tableData?.map((item, index) => (
                    <ProjectExpertRow
                      key={index}
                      data={item}
                      project_id={project?.id}
                      appendExpertId={appendExpertId}
                      removeExpertId={removeExpertId}
                      project_name={project?.name}
                      project={project}
                      titleCount={titleCount}
                      setTitleCount={setTitleCount}
                      backupData={backupData}
                      // setBackupData={setBackupData}
                      filterCount={filterCount}
                      setEmailButtonClicked={setEmailButtonClicked}
                      setSelectedConsulData={setSelectedConsulData}
                      setEmailDetails={setEmailDetails}
                      setComposeEmail={setComposeEmail}
                      fieldsLoading={fieldsLoading}
                    />
                  ))}
                {tableData && tableData?.length === 0 && (
                  <div className="topCon-table-row">
                    <div className="topCon-top-div" style={{ height: "100px" }}>
                      <h5 style={{ textAlign: "center", paddingTop: "10px" }}>
                        {!loading ? (
                          "No consultant found"
                        ) : (
                          <div style={{ textAlign: "center", marginTop: "20px" }}>
                            <img
                              src={LoadingIcon}
                              alt="Loading..."
                              style={{ height: "50px" }}
                            />
                            <h4 style={{ marginTop: "20px" }}>please wait</h4>
                          </div>
                        )}
                      </h5>
                    </div>
                    <div className="topCon-row-bottom"></div>
                  </div>
                )}
                {composeEmail && (
                  <EmailComposer
                    emailDetails={emailDetails}
                    onClose={() => setComposeEmail(false)}
                    onSend={(modifiedEmail) => {
                      setLoadingPopup(true);
                      // Handle the sending logic here, e.g., make an API call to send the modified email
                      console.log("Sending modified email:", modifiedEmail);
                      // Close the EmailComposer component
                      const authToken = localStorage.getItem("accesstoken");
                      const tokenObj = localStorage.getItem("eph-token");
                      const url = `${API_URL}send-email-through-graphapi`;
                      // const url = "${API_URL}api/send-email-through-graphapi";
                      fetch(url, {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          "x-access-token": authToken,
                          tokenObj: JSON.parse(tokenObj).value,
                        },
                        body: JSON.stringify(modifiedEmail),
                      })
                        .then((res) => res.json())
                        .then((data) => {
                          if (data.status === "success") {
                            setLoadingPopup(false);
                            setComposeEmail(false);
                            Swal.fire({
                              icon: "success",
                              title: "Email sent successfully",
                              showConfirmButton: false,
                              timer: 1500,
                            });
                          } else if (data.status === "error") {
                            Swal.fire({
                              icon: "success",
                              title: "Error",
                              text: `${data.message}`,
                              showConfirmButton: false,
                              timer: 1500,
                            });
                          }

                          // setProjectInfo(data.projectInfo);
                        })
                        .catch((err) => console.log(err));
                    }}
                  />
                )}
                {noConFound && (
                  <div className="topCon-table-row">
                    <div className="topCon-top-div" style={{ height: "45px" }}>
                      <h5 style={{ textAlign: "center", paddingTop: "10px" }}>
                        No consultant added yet
                      </h5>
                    </div>
                    <div className="topCon-row-bottom"></div>
                  </div>
                )}
              </>
            ) : (
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <img
                  src={LoadingIcon}
                  alt="Loading..."
                  style={{ height: "50px" }}
                />
                <h4 style={{ marginTop: "20px" }}>please wait</h4>
              </div>
            )}
            {loadingPopup && (
              <div className="deletePrj-popup-wrapper">
                <div className="tab-pane fade show deletePrj-div">
                  <center>
                    <p style={{ fontSize: "18px" }}>Please wait . . .</p>
                    <br />
                    <img
                      src={LoadingIcon}
                      alt=""
                      style={{ width: "50px", marginRight: "5px" }}
                    />
                  </center>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {openSearch && (
        <DatabasePopupList projectID={id} setOpenSearch={setOpenSearch} />
      )}
    </>
  );
}
